var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup30836(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 34,
    viewBox: "0 0 135 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2635 1.08844L55.3692 0.5H54.7713H33.7137H33.295L33.2215 0.912114L27.5078 32.9121L27.4028 33.5H28H35.8793H36.2987L36.3717 33.087L38.6026 20.463H48.044H48.4593L48.5355 20.0547L49.6413 14.1288L49.7518 13.537H49.1498H39.8837L40.9076 7.65385H53.6655H54.0836L54.1576 7.24228L55.2635 1.08844ZM70.2737 33.5H70.4359H78.5217H78.8248L78.965 33.2313L81.7738 27.8476H93.1181L93.9712 33.0805L94.0396 33.5H94.4647H102.805H103.407L103.296 32.908L97.3062 0.908002L97.2298 0.5H96.8147H87.6912H87.3941L87.2521 0.760966L70.9271 30.7538L71.5694 27.1621L71.6746 26.5741H71.0772H61.3529L65.9018 1.08786L66.0068 0.5H65.4096H57.5303H57.1116L57.0381 0.912114L51.3244 32.9121L51.2194 33.5H51.8166H69.4323H70.0174H70.2737ZM121.711 7.88177L105.116 26.7438L105.024 26.8486L104.999 26.986L103.939 32.912L103.834 33.5H104.432H127.286H127.704L127.778 33.0888L128.93 26.7071L129.037 26.1182H128.438H115.632L132.315 7.25718L132.408 7.15208L132.432 7.01395L133.492 1.08802L133.597 0.5H133H110.145H109.727L109.653 0.911182L108.501 7.29295L108.395 7.88177H108.993H121.711ZM85.3822 20.9217L90.4768 11.1426L92.0356 20.9217H85.3822Z",
    fill: "#0C213A",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1L19.5446 33H12L17.4554 1H25Z",
    fill: "#80B7EA",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1L9.12494 33H1L6.875 1H15Z",
    fill: "#348BDC",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30836);
export default __webpack_public_path__ + "static/media/Group 30836.8043088fad6b9a1f7be22260c9d0b363.svg";
export { ForwardRef as ReactComponent };